const SUPPORTED_LOAN_TERMS = [
	'3 ARM',
	'5 ARM',
	'7 ARM',
	'10 ARM',
	'10 Year Fixed',
	'15 Year Fixed',
	'20 Year Fixed',
	'30 Year Fixed',
	'40 Year Fixed'
];

export default SUPPORTED_LOAN_TERMS;
